import React, { useState, useEffect } from "react";
import ReactIdSwiper from "react-id-swiper";

export default (props) => {
  // //console.log(props);
  var data = props.data;
  // Swiper instance
  const [swiper, updateSwiper] = useState(null);
  // Slides current index
  const [currentIndex, updateCurrentIndex] = useState(0);
  var elePagi = ".swiper-pagination";
  if (props.page == "home-banners") {
    elePagi = ".swiper-pagination.swiper-pagination-white";
  }
  var params = {};
  // Params definition
 (props.page == "dr-carousel-unit")
    params = {
      loop: false,
      slidesPerView: 6,
      spaceBetween: 10,
      breakpoints: {
        320: {
          slidesPerView: 4.4,
          spaceBetween: 0
        },
        480: {
          slidesPerView: 4.4,
          spaceBetween:0
        },
        640: {
          slidesPerView: 4.4,
          spaceBetween: 0
        }
      },
      getSwiper: updateSwiper // Get swiper instance callback
    }
  

  // Manipulate swiper from outside
  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };

  // Add eventlisteners for swiper after initializing
  useEffect(() => {
    if (swiper !== null) {
      swiper.on("slideChange", () => updateCurrentIndex(swiper.realIndex));
    }

    return () => {
      if (swiper !== null) {
        swiper.off("slideChange", () => updateCurrentIndex(swiper.realIndex));
      }
    };
  }, [swiper]);

  return (
    <div>
      <ReactIdSwiper {...params}>
        {data.map((item, idx) => (
          (props.page == "dr-carousel-unit" ?
            <div className="swiper-slide_feed gtm-main-data" data-menuname={item.name} data-range={item.name} data-gender={item.name} key={idx}>
              <div className="all_tools_bar">
                  <a href={item.redirectionUrl} className="gtmMenu" tabIndex={0} aria-label={item.arialabel}>
                  <div className="all_tools-icons "> 
                      <img className='tools-icons-normal gtmMenu' src={item.img} alt={item.name} title={item.name} />
                      <img className="tools-icons-active gtmMenu" src={item.img2} alt={item.name} title={item.name} />
                  </div>
                <div className="nav-tools-heading R12_42 gtmMenu"> {item.name} </div> 
                      </a>
              </div>
            </div>
            :
            <div className="swiper-slide_feed" key={idx}>
              <img src="https://bbcdnlivemumbai.s3.ap-south-1.amazonaws.com/brainbees/community/memoryimages/1584339297p4706331.jpeg" alt="" />
            </div>
          )
        ))}
      </ReactIdSwiper>
      <div className="buttons buttons-list" style={{ display: "none" }}>
        <button id="prevSlide" className="button is-primary" onClick={goPrev} aria-label="Previous">
          Prev
        </button>
        <button id="nextSlide" className="button is-primary" onClick={goNext} aria-label="Next">
          Next
        </button>
      </div>
    </div>
  );
};
